import axios from 'axios';
import Storage from 'services/storage2';
import User from 'services/user2';
import { UserResponse } from 'interface/response';

const instAxios = axios.create({
  timeout: 600000
});

instAxios.interceptors.request.use(
  function (config) {
    let companyCode = Storage.getItem('companyCode');
    //偶尔header企业号会传'null'
    if ((!companyCode || companyCode === 'null') && User) {
      companyCode = User.getCompanyCode();
    }
    config.headers = {
      'Company-Code': companyCode,
      'Source-Page': window.location.pathname,
      'Visit-Source': '1002'
    };

    let url: string = config.url || '';
    let apiPath = config.data.apiPath;
    if (/^\/api\/.+/.test(url)) {
      //url增加方法路径及方法名便于调试
      if (apiPath !== undefined) {
        let methodName = apiPath.replace(/\//g, '_');
        config.url = url + '/' + methodName;
      }
    }
    return config;
  },
  function (error) {
    //Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
instAxios.interceptors.response.use(
  function (response) {
    //Do something with response data
    return response.data || {};
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

const Http = {
  post: async (url: string, postbody: any) => {
    let rs: UserResponse = {};
    await instAxios.post(url, postbody).then(response => {
      rs = response;
    });
    return rs;
  }
};

export default Http;
